import React from 'react';

type Props = {
  children: React.ReactNode;
  /** Optional label for devtools logging (e.g. section type). */
  name?: string;
};

type State = {
  hasError: boolean;
};

/**
 * Isolates a single home section so a render error in one block
 * (e.g. recommendations) does not blank the entire page in WebView/mobile.
 */
export class SectionErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(
        `[SectionErrorBoundary${this.props.name ? `: ${this.props.name}` : ''}]`,
        error,
        info.componentStack,
      );
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
